import { useTranslation } from "react-i18next";
import Dialog from "src/components/Dialog";

export default function CannotSaveDialog({ isOpen, onDismiss }) {
  const { t } = useTranslation();
  return (
    <Dialog
      zIndex={200}
      type="failure"
      isOpen={isOpen}
      heading={t("scheduler.overlap.heading")}
      text={t("scheduler.overlap.text")}
      buttons={[
        {
          text: t("buttons.ok"),
          onClick: onDismiss
        }
      ]}
    />
  );
}
